import { EnvironmentProviders, Provider } from '@angular/core';
import { FP_CORRELATION_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/providers/fp-correlation-tab-connect-services.token';
import { FpCorrelationCommentsConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-comments/services/fp-correlation-comments-connect.service';
import { FpCorrelationCommentsStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-comments/services/fp-correlation-comments/fp-correlation-comments.store';

export function fpCorrelationCommentsProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpCorrelationCommentsStore,
    FpCorrelationCommentsConnectService,
    {
      provide: FP_CORRELATION_TAB_CONNECT_SERVICES,
      useExisting: FpCorrelationCommentsConnectService,
      multi: true,
    },
  ];
}
